import React from 'react';

type Props = {
  activeStep: number;
};
const steps = [
  {
    title: 'Guest Information',
    stepNo: 1,
    stepBar: (
      <>
        <div className="col d-none d-sm-block">
          <div className="w-full h-1 bg-border"></div>
        </div>
      </>
    ),
  },
  {
    title: 'Payment Details',
    stepNo: 2,
    stepBar: (
      <>
        <div className="col d-none d-sm-block">
          <div className="w-full h-1 bg-border"></div>
        </div>
      </>
    ),
  },
  {
    title: 'Booking completed',
    stepNo: 3,
  },
];
export default function BookingStep({ activeStep }: Props) {
  return (
    <div className="row x-gap-40 y-gap-30 items-center sm:d-none md:d-none">
      {steps.map(step => (
        <React.Fragment key={step.stepNo}>
          <div className="col-auto">
            <div className="d-flex items-center transition">
              <div
                className={
                  activeStep === step.stepNo
                    ? 'active size-40 rounded-full flex-center bg-blue-1'
                    : 'size-40 rounded-full flex-center bg-blue-1-05 text-blue-1 fw-500'
                }
              >
                {activeStep === step.stepNo ? (
                  <>
                    <i className="icon-check text-16 text-white"></i>
                  </>
                ) : (
                  <>
                    <span>{step.stepNo}</span>
                  </>
                )}
              </div>
              <div className="text-18 fw-500 ml-10"> {step.title}</div>
            </div>
          </div>

          {step.stepBar}
        </React.Fragment>
      ))}
    </div>
  );
}
